import './../css/GSideBar.css';
import './../css/GMediaQuery.css';
import './../css/GAnimetion.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { systemConfiguration } from "../../CommonImports";

function GEmployersSider() {
    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';
    return (
        <div className="col-lg-4 col-md-12 col-sm-12 col-12 pl-40 pl-lg-15 mt-lg-30">
            <div className="sidebar-shadow">
                <h5 className="font-bold">Overview</h5>
                <div className="sidebar-list-job mt-10">
                    <ul>
                        <li>
                            <div className="sidebar-icon-item"><i className="fi-rr-briefcase"></i></div>
                            <div className="sidebar-text-info">
                                <span className="text-description">Company field</span>
                                <strong className="small-heading">Accounting / Finance</strong>
                            </div>
                        </li>
                        <li>
                            <div className="sidebar-icon-item"><i className="fi-rr-marker"></i></div>
                            <div className="sidebar-text-info">
                                <span className="text-description">Location</span>
                                <strong className="small-heading">Dallas, Texas<br/>Remote Friendly</strong>
                            </div>
                        </li>
                        <li>
                            <div className="sidebar-icon-item"><i className="fi-rr-dollar"></i></div>
                            <div className="sidebar-text-info">
                                <span className="text-description">Salary</span>
                                <strong className="small-heading">$35k - $45k</strong>
                            </div>
                        </li>
                        <li>
                            <div className="sidebar-icon-item"><i className="fi-rr-clock"></i></div>
                            <div className="sidebar-text-info">
                                <span className="text-description">Member since</span>
                                <strong className="small-heading">Jul 2012</strong>
                            </div>
                        </li>
                        <li>
                            <div className="sidebar-icon-item"><i className="fi-rr-time-fast"></i></div>
                            <div className="sidebar-text-info">
                                <span className="text-description">Last Jobs Posted</span>
                                <strong className="small-heading">4 days</strong>
                            </div>
                        </li>
                    </ul>
                </div>

                <div className="sidebar-list-job mt-10">
                    <a href="#" className="btn btn-default mr-10">Contact Us</a>
                    <a href="#" className="btn btn-border">Send message</a>
                </div>

                <div className="sidebar-team-member pt-4">
                    <h6 className="small-heading">Team member</h6>
                    <div className="sidebar-list-member">
                        <ul className="list-unstyled d-flex flex-wrap">
                            {["avatar1.png", "avatar2.png", "avatar3.png", "avatar4.png", "avatar5.png", "avatar6.png", "avatar7.png", "avatar8.png"].map((avatar, index) => (
                                <li key={index}>
                                    <a href="#">
                                        <figure>
                                            <img alt="jobhub" src={mediaUrl + avatar + "?" + sasToken} className="img-fluid rounded-circle" />
                                        </figure>
                                    </a>
                                </li>
                            ))}
                        </ul>

                    </div>
                </div>
            </div>

            <div className="sidebar-shadow">
                <div className="block-tags">
                    <a href="#" className="btn btn-tags-sm mb-10 mr-5">Figma</a>
                    <a href="#" className="btn btn-tags-sm mb-10 mr-5">Adobe XD</a>
                    <a href="#" className="btn btn-tags-sm mb-10 mr-5">PSD</a>
                    <a href="#" className="btn btn-tags-sm mb-10 mr-5">HTML 5</a>
                    <a href="#" className="btn btn-tags-sm mb-10 mr-5">Css 3</a>
                    <a href="#" className="btn btn-tags-sm mb-10 mr-5">Javascript</a>
                    <a href="#" className="btn btn-tags-sm mb-10 mr-5">Jquery</a>
                    <a href="#" className="btn btn-tags-sm mb-10 mr-5">NodeJS</a>
                    <a href="#" className="btn btn-tags-sm mb-10 mr-5">MongoDb</a>
                    <a href="#" className="btn btn-tags-sm mb-10 mr-5">SEO expert</a>
                    <a href="#" className="btn btn-tags-sm mb-10 mr-5">Gimp</a>
                    <a href="#" className="btn btn-tags-sm mb-10 mr-5">PSD</a>
                    <a href="#" className="btn btn-tags-sm mb-10 mr-5">Photo editing</a>
                    <a href="#" className="btn btn-tags-sm mb-10 mr-5">Sketch</a>
                    <a href="#" className="btn btn-tags-sm mb-10 mr-5">jam</a>
                </div>
            </div>
            <div className="sidebar-normal">
                <div>
                    <h6 className="small-heading">Are you also hiring?</h6>
                    <ul className="ul-lists">
                        <li><a href="#">Writing &amp; Translation</a></li>
                        <li><a href="#">Video &amp; Animation</a></li>
                        <li><a href="#">Music &amp; Audio</a></li>
                        <li><a href="#">Digital Marketing</a></li>
                        <li><a href="#">Business</a></li>
                        <li><a href="#">Programming &amp; Tech</a></li>
                    </ul>
                </div>
            </div>
        </div>
    )

}
export default GEmployersSider;